import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/global.css'
import request from "@/utils/request";
import { isAuthExpiredError } from "@/utils/auth";

// main.js全局注册
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// use
Vue.use(mavonEditor);
Vue.use(Viewer);
Vue.use(VueQuillEditor);

Vue.config.productionTip = false

Vue.use(ElementUI, {zIndex:1000,size:"mini"});

// Vue.use(ElementUI, { size: "mini" });

Vue.prototype.request=request

window.addEventListener('unhandledrejection', (event) => {
  if (isAuthExpiredError(event.reason)) {
    event.preventDefault()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

